import { LanguageId } from 'lib-knowledge-management-common/graphql';

// TODO: move to management
export const DEFAULT_LANG_CODE = LanguageId.En;
